import React from 'react'
import { Text, Flex } from 'pcln-design-system'
import PropTypes from 'prop-types'
import SliceDisplay from './SliceDisplay'

const SliceDetails = ({
  airline,
  arrival,
  departing,
  layoverInfo,
  operatedByText,
  isDepartureSummary,
  altDateText,
  airlineTestId,
  hideStops,
  showAirportToolTip,
  isMobile,
  disableLayoverTooltip,
  isMultipleAirlinesLogoVariant,
  multipleAirlineText,
  ...props
}) => {
  let jetBlueMessaging = false
  let operatedByCarrierText = operatedByText
  if (operatedByText?.toLowerCase()?.includes('jetblue') && !operatedByText?.includes(',')) {
    operatedByCarrierText = operatedByText.replace('Operated by', '')
    jetBlueMessaging = true
  }

  return (
    <Flex flexDirection='column' pb={!operatedByText && '24px'} {...props}>
      <SliceDisplay
        alignItems='center'
        layoverInfo={layoverInfo}
        departing={departing}
        arrival={arrival}
        airline={airline}
        isDepartureSummary={isDepartureSummary}
        altDateText={altDateText}
        airlineTestId={airlineTestId}
        hideStops={hideStops}
        showAirportToolTip={showAirportToolTip}
        isMobile={isMobile}
        disableLayoverTooltip={disableLayoverTooltip}
        isMultipleAirlinesLogoVariant={isMultipleAirlinesLogoVariant}
        multipleAirlineText={multipleAirlineText}
      />
      {jetBlueMessaging && (
        <Flex pr='24px'>
          <Text
            color={isDepartureSummary ? 'text.base' : 'text.light'}
            mt={2}
            fontSize='10px'
            lineHeight='16px'
          >
            Operated by
          </Text>
          &nbsp;
          <Text
            bold
            color={isDepartureSummary ? 'text.base' : 'text.light'}
            mt={2}
            fontSize='10px'
            lineHeight='16px'
          >
            {operatedByCarrierText}
          </Text>
        </Flex>
      )}
      {operatedByText && !jetBlueMessaging && (
        <Text
          color={isDepartureSummary ? 'text.base' : 'text.light'}
          mt={2}
          mb={isDepartureSummary ? 2 : 0}
          fontSize='10px'
          lineHeight='16px'
          pr='24px'
        >
          {operatedByText}
        </Text>
      )}
    </Flex>
  )
}

SliceDetails.propTypes = {
  /** Airline data for logo and airline name */
  airline: PropTypes.shape({
    name: PropTypes.string,
    image: PropTypes.string,
  }),

  /** Arrival data containing time and airport */
  arrival: PropTypes.shape({
    time: PropTypes.string,
    airport: PropTypes.string,
    overnightDays: PropTypes.number,
    isAltAirport: PropTypes.bool,
  }),

  /** Departing data containing time and airport */
  departing: PropTypes.shape({
    time: PropTypes.string,
    airport: PropTypes.string,
    isAltAirport: PropTypes.bool,
  }),

  /** List of layover durations and locations  */
  layoverInfo: PropTypes.arrayOf(PropTypes.object),

  /** Operated by text if airline is operated by another airline */
  operatedByText: PropTypes.string,

  /** if is used within DepartureSummary component */
  isDepartureSummary: PropTypes.bool,

  /* Alt Date string to display alt date above time */
  altDateText: PropTypes.string,

  /** Test identifier for airline */
  airlineTestId: PropTypes.string,

  /** Hide stops at smaller breakpoints */
  hideStops: PropTypes.bool,

  /** Seti for display hover tooltip for airports */
  showAirportToolTip: PropTypes.bool,

  /** Bool for determining if mobile user */
  isMobile: PropTypes.bool,

  /** Disable the tooltips on the layovers */
  disableLayoverTooltip: PropTypes.bool,

  isMultipleAirlinesLogoVariant: PropTypes.bool,

  multipleAirlineText: PropTypes.string,
}

export default SliceDetails
